module.exports = __webpack_public_path__ + "img/anquan3-1.fb8dcab6.jpg";